import angular from 'angular';
import CategoriesAccordion from './categories-accordion.component';

let CategoriesAccordionModule = angular.module('catalog.categoriesAccordion', [])
  .component('categoriesAccordion', CategoriesAccordion);

export default CategoriesAccordionModule;



// WEBPACK FOOTER //
// ./www/components/catalog/categories-filter/categories-accordion/categories-accordion.js